import { render, staticRenderFns } from "./DellSelect.vue?vue&type=template&id=3f81da65&scoped=true&"
import script from "./DellSelect.vue?vue&type=script&lang=js&"
export * from "./DellSelect.vue?vue&type=script&lang=js&"
import style0 from "./DellSelect.vue?vue&type=style&index=0&id=3f81da65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f81da65",
  null
  
)

export default component.exports